import AddIcon from '@mui/icons-material/Add'
import { Alert, DialogContent, Snackbar } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import { useImportModelMutation } from 'apollo/configurator/mutations/ImportModel.generated'
import { useRootNodesQuery } from 'apollo/configurator/queries/RootNodes.generated'
import {
    executeImport,
    handleImportModel
} from 'components/modelManager/molecules/manager/helpers/ImportExportModel'
import { useState } from 'react'
import { Loading } from 'react-admin'
import MiniPresetList from './helpers/MiniPresetList'

const ImportModelButton = () => {
    const [duplicateCode, setDuplicateCode] = useState(false)

    const [preImportModel, setPreImportModel] = useState<any | null>(null)

    const [importModelMutation, { loading }] = useImportModelMutation({
        variables: {
            json: '' // value for 'json'
        },
        fetchPolicy: 'network-only'
    })
    const { data: { configuratorNodes: nodes } = {} } = useRootNodesQuery()

    const modelsCodes = nodes && nodes.map((node) => node?.code)

    return (
        <>
            <Button
                sx={{ ml: 1 }}
                variant="contained"
                color="secondary"
                size="small"
                onClick={() => handleImportModel(modelsCodes, setDuplicateCode, setPreImportModel)}
            >
                <AddIcon />
                Import model
            </Button>
            {/* Import spinner */}
            <Dialog
                open={loading || preImportModel !== null}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent
                    style={{
                        textAlign: 'center',
                        display: preImportModel == null ? 'block' : 'none'
                    }}
                >
                    <Loading
                        loadingPrimary="Import in progress"
                        loadingSecondary="Do not refresh or close the page"
                    />
                </DialogContent>
                <DialogContent
                    style={{
                        textAlign: 'left',
                        display: preImportModel == null ? 'none' : 'block',
                        padding: '40px 40px 20px 40px'
                    }}
                >
                    <MiniPresetList
                        presets={preImportModel?.presets}
                        model={preImportModel?.model}
                    ></MiniPresetList>
                    <br />
                    <Button
                        style={{ margin: '10px' }}
                        variant="contained"
                        color="secondary"
                        onClick={() => setPreImportModel(null)}
                    >
                        Cancel
                    </Button>

                    <Button
                        style={{ margin: '10px' }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            executeImport(JSON.stringify(preImportModel), importModelMutation)
                            setPreImportModel(null)
                        }}
                    >
                        Confirm import
                    </Button>
                </DialogContent>
            </Dialog>
            <Snackbar
                open={duplicateCode}
                onClose={() => setDuplicateCode(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                key={Date.now()}
            >
                <Alert onClose={() => setDuplicateCode(false)} severity="error">
                    There is a model with the same Model Code!
                </Alert>
            </Snackbar>
        </>
    )
}

export default ImportModelButton
